"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NUMBER_OF_ARTICLES = exports.EDITORIAL_CAROUSEL_SECTION_SKELETON = exports.EDITORIAL_CAROUSEL_SECTION_BUTTON_SKELETON = void 0;
const EDITORIAL_CAROUSEL_SECTION_SKELETON = exports.EDITORIAL_CAROUSEL_SECTION_SKELETON = 'editorial-carousel-section-skeleton';
const EDITORIAL_CAROUSEL_SECTION_BUTTON_SKELETON = exports.EDITORIAL_CAROUSEL_SECTION_BUTTON_SKELETON = 'editorial-carousel-section-button-skeleton';
const NUMBER_OF_ARTICLES = exports.NUMBER_OF_ARTICLES = 6;
